<ng-container *ngIf="info as p">
  <ng-container *ngIf="hasContent">
    <details
      #d
      class="gw-bg-background-elevation-2 gw-border-base gw-rounded-2xl gw-overflow-hidden gw-gatewee-collapsible-details"
    >
      <summary
        class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-small gw-rounded-t-2xl gw-p-medium gw-cursor-pointer gw-list-none gw-select-none gw-outline-none gw-transition-colors gw-duration-300 gw-ease-out hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
      >
        <span class="gw-flex gw-items-center gw-gap-small gw-min-w-0">
          <gatewee-icon
            [icon]="'@tui.arrow-down-circle'"
            class="gw-shrink-0 gw-text-text-primary"
          ></gatewee-icon>
          <span class="gw-text-base gw-font-semibold gw-text-text-primary">
            {{ 'common.withdrawalReceiver.title' | translate }}
          </span>
        </span>
        <span
          class="gw-flex gw-min-w-0 gw-max-w-[55%] gw-items-center gw-justify-end gw-gap-2x-small"
        >
          <span
            *ngIf="p.holderName || p.name"
            class="gw-truncate gw-text-sm gw-font-medium gw-text-text-secondary"
          >
            {{ p.holderName || p.name }}
          </span>
          <gatewee-expand-chevron
            [expanded]="d.open"
            class="gw-inline-flex gw-shrink-0 gw-text-text-secondary"
          ></gatewee-expand-chevron>
        </span>
      </summary>
      <div class="gw-gatewee-collapsible-panel">
        <div
          class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-px-medium gw-pb-medium gw-pt-medium"
        >
          <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-medium">
            <div *ngIf="p.holderName || p.name">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.withdrawalReceiver.holderName' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary">
                {{ p.holderName || p.name }}
              </p>
            </div>
            <div *ngIf="p.holderDocument || p.document">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.withdrawalReceiver.holderDocument' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary">
                {{ p.holderDocument || p.document || '' | document : true }}
              </p>
            </div>
            <div *ngIf="p.pixKey">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.withdrawalReceiver.pixKey' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary gw-break-all">
                {{ p.pixKey | pixKey }}
              </p>
            </div>
            <div *ngIf="p.pixKeyType">
              <p
                class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
              >
                {{ 'common.withdrawalReceiver.pixKeyType' | translate }}
              </p>
              <p class="gw-text-base gw-text-text-primary">
                {{ 'enums.pixKeyTypes.' + p.pixKeyType | translate }}
              </p>
            </div>
          </div>
          <div *ngIf="p.emvCode" class="gw-mt-medium">
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
            >
              {{ 'common.withdrawalReceiver.emvCode' | translate }}
            </p>
            <p
              class="gw-text-xs gw-font-mono gw-text-text-primary gw-break-all gw-p-small gw-rounded-lg gw-bg-background-elevation-2"
            >
              {{ p.emvCode }}
            </p>
          </div>
          <div *ngIf="p.digitableLine" class="gw-mt-medium">
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-medium"
            >
              {{ 'common.withdrawalReceiver.digitableLine' | translate }}
            </p>
            <p
              class="gw-text-xs gw-font-mono gw-text-text-primary gw-break-all gw-tabular-nums gw-p-small gw-rounded-lg gw-bg-background-elevation-2"
            >
              {{ p.digitableLine }}
            </p>
          </div>
        </div>
      </div>
    </details>
  </ng-container>
</ng-container>
